import React from "react";
import { RefreshCw } from "lucide-react";
import { useAuth } from "../AuthContext";
import PulseTeaser from "./PulseTeaser";
import WorldPulse from "./WorldPulse";

/** /pulse — anonymous visitors get the public SEO/AEO teaser,
 *  authenticated users get the World Pulse landing. */
export default function PulsePage() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <RefreshCw className="w-5 h-5 animate-spin text-[#006874]" />
      </div>
    );
  }
  return user ? <WorldPulse /> : <PulseTeaser />;
}
